import { render } from "./CancellazioneDati.vue?vue&type=template&id=1b7b8267&scoped=true"
import script from "./CancellazioneDati.vue?vue&type=script&lang=js"
export * from "./CancellazioneDati.vue?vue&type=script&lang=js"

import "./CancellazioneDati.vue?vue&type=style&index=0&id=1b7b8267&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b7b8267"]])

export default __exports__